/**
 * Default width÷height for handwriting stationery grid tiles and CDN `scale-down` thumbs:
 * landscape preview PNGs are **300×200** (3∶2) when meta has no `referenceCanvasPx`.
 */
export const STATIONERY_GRID_PREVIEW_ASPECT_WH = 3 / 2
